export type PriceCatalogueUsageTier = {
  upTo: number | null;
  flatFeeMinorUnits: number | null;
  unitFeeDecimal: string | null;
};

export type PriceCatalogueUsageRule = {
  payableEntityType: string;
  pricingMetric: string;
  tiers: PriceCatalogueUsageTier[];
};

export type PriceCatalogueFixedMonthlyPlan = {
  payableEntityType: string;
  key: string;
  monthlyFeeMinorUnits: number;
  transactionLimit: number;
};

export type PriceCatalogueProfile = {
  id: string;
  key: string;
  label: string;
  subscriptionOption: string;
  subscriptionLevel: string | null;
  billingCurrency: string;
  interval: string | null;
  pricingType: "fixed" | "usage_tiered" | "fixed_monthly_plan" | string;
  fixedPriceMinorUnits?: number | null;
  usagePricing?: PriceCatalogueUsageRule[] | null;
  fixedMonthlyPlans?: PriceCatalogueFixedMonthlyPlan[] | null;
  subscriptionId?: string;
  legacyProviderPriceId?: string | null;
};

export type PriceCatalogueFilters = {
  subscriptionOption: string;
  subscriptionLevel: string;
  billingCurrency: string;
  interval: string;
};

export const EMPTY_PRICE_CATALOGUE_FILTERS: PriceCatalogueFilters = {
  subscriptionOption: "",
  subscriptionLevel: "",
  billingCurrency: "",
  interval: "",
};

export const SUBSCRIPTION_OPTION_FILTERS = [
  { label: "All options", value: "" },
  { label: "Toolkit", value: "TOOLKIT" },
  { label: "Toolkit Mobile", value: "TOOLKIT_MOBILE" },
  { label: "Payments Only", value: "PAYMENTS_ONLY" },
  { label: "Shopify B2B", value: "SHOPIFY_B2B_SUBSCRIPTION" },
];

export const SUBSCRIPTION_LEVEL_FILTERS = [
  { label: "All levels", value: "" },
  { label: "Basic", value: "BASIC" },
  { label: "Starter", value: "STARTER" },
  { label: "Scale Up", value: "SCALE_UP" },
  { label: "Professional", value: "PROFESSIONAL" },
  { label: "Enterprise", value: "ENTERPRISE" },
];

export const BILLING_CURRENCY_FILTERS = [
  { label: "All currencies", value: "" },
  { label: "GBP", value: "gbp" },
  { label: "EUR", value: "eur" },
  { label: "USD", value: "usd" },
];

export const INTERVAL_FILTERS = [
  { label: "All intervals", value: "" },
  { label: "Month", value: "MONTH" },
  { label: "Year", value: "YEAR" },
];

export const PAYABLE_ENTITY_TAB_LABELS: Record<string, string> = {
  Payment: "Single Payments",
  RecurringPayment: "Recurring",
  BulkPayment: "Bulk",
  VrpPayment: "VRPs",
};

export const formatMinorUnits = (
  minor?: number | null,
  currency?: string | null
): string => {
  if (minor == null) return "—";
  const code = String(currency || "gbp").toUpperCase();
  try {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: code,
    }).format(minor / 100);
  } catch {
    return `${(minor / 100).toFixed(2)} ${code}`;
  }
};
